//@ts-nocheck

export const Avatar = ({ src, alt, size = 40, initials }) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#ddd',
        fontSize: size / 2.5,
        fontWeight: 'bold',
        color: '#555',
      }}
    >
      {src ? (
        <img src={src} alt={alt} style={{ width: '100%', height: '100%' }} />
      ) : (
        initials
      )}
    </div>
  );
};

export const AvatarGroup = ({ avatars, max = 3, size = 40, limit }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {avatars.slice(0, max).map((avatar, index) => (
        <div
          key={index}
          style={{
            marginLeft: index === 0 ? 0 : -size / 4,
            border: '2px solid white',
            borderRadius: '50%',
            overflow: 'hidden',
          }}
        >
          <Avatar
            src={avatar.src}
            alt={avatar.alt}
            size={size}
            initials={avatar.initials}
          />
        </div>
      ))}
      {avatars.length > max && (
        <div
          style={{
            width: size,
            height: size,
            borderRadius: '50%',
            backgroundColor: '#bbb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: size / 3,
            fontWeight: 'bold',
            color: 'white',
            marginLeft: -size / 4,
            border: '2px solid white',
          }}
        >
          +{limit}
        </div>
      )}
    </div>
  );
};
